<template>
    <ul
        class="tab-view"
        data-test-id="tab-view"
    >
        <li
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{ active: index === activeTab }"
            :data-test-id="`tab-${index}`"
            @click.prevent="$emit('tab-clicked', index)"
        >
            {{ tab.label }}
        </li>
    </ul>
</template>

<script>
export default {
    name: 'TabView',
    props: {
        activeTab: {
            type: Number,
            required: false,
            default: 0,
        },
        tabs: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['tab-clicked'],
}
</script>
<style lang="scss">
.tab-view {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;

    li {
        border: 1px solid #888;
        color: #fff;
        font-size: 14px;
        background-color: transparent;
        padding: 10px 12px;
        min-width: 160px;
        height: 40px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    li:first-child {
        border-radius: 8px 0 0 8px;
    }

    li:not(:last-child) {
        border-right-width: 0;
    }

    li:last-child {
        border-radius: 0 8px 8px 0;
    }

    li.active,
    li:hover {
        background-color: #212628;
    }
}
</style>
